export default function PrintOrderReceipt(requestDetails: any) {
  const win = window.open("", "_blank");
  if (!win) return;

  const doc = win.document;

  const title = doc.createElement("title");
  title.textContent = `Order Receipt - Cinderbuild`;
  doc.head.appendChild(title);

  const style = doc.createElement("style");
  style.textContent = `
    body {
      font-family: Arial, sans-serif;
      padding: 24px;
      color: #222;
    }

    .header {
      margin-bottom: 20px;
    }

    .status {
      display: inline-block;
      padding: 6px 12px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: bold;
      margin-bottom: 10px;
      background: #f3f3f3;
    }

    .section-title {
        font-size: 15px;
        margin: 20px 0 8px;
        font-weight: bold;
    }

    .row {
      margin-bottom: 6px;
      font-size: 14px;
    }

    h2, h3 {
      margin: 16px 0 8px;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 10px;
      font-size: 14px;
    }

    th, td {
      border: 1px solid #ddd;
      padding: 8px;
      text-align: left;
    }

    th {
      background: #f5f5f5;
    }

    .total-section {
      margin-top: 16px;
      width: 320px;
      margin-left: auto;
      font-size: 14px;
    }

    .total-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 6px;
    }

    .grand-total {
      font-weight: bold;
      font-size: 16px;
      border-top: 1px solid #ddd;
      padding-top: 6px;
      margin-top: 6px;
    }

    .footer {
      margin-top: 40px;
      font-size: 12px;
      color: #777;
      text-align: center;
    }
  `;
  doc.head.appendChild(style);

  const container = doc.createElement("div");

  const currency = (v: any) =>
    v !== undefined && v !== null ? `₦${Number(v).toLocaleString()}` : "Nil";

  const items = requestDetails?.orderItems || [];

  const formattedItems = items.map((item: any) => ({
    name: item?.productName || "",
    unitPrice: currency(item?.unitPrice || 0),
    buyerPrice: currency(item?.unitPriceForBuyer || 0),
  }));

  const deliveryFee = requestDetails?.deliveryCostMajor;

  const itemsTotalValue = items.reduce(
    (acc: any, item: any) => acc + (item?.unitPriceForBuyer || 0),
    0,
  );

  const itemsTotal = currency(itemsTotalValue);

  const total = currency(requestDetails?.calculatedTotalCostMajor || 0);

  container.innerHTML = `
    <div class="header">
      <h2>Order Receipt</h2>

      <div class="row"><strong>Order ID:</strong> ${requestDetails?.id || ""}</div>
      <div class="row"><strong>Date:</strong>${new Date(requestDetails?.createdAt).toLocaleDateString()}</div>
    </div>

    <div class="section-title">Customer</div>
      <div>
        ${requestDetails?.buyerPublicProfile?.firstName ?? ""}
        ${requestDetails?.buyerPublicProfile?.lastName ?? ""}
      </div>
      <div>${requestDetails?.orderLocation?.address ?? ""}</div>

    <h3>Order Items</h3>

    <table>
      <thead>
        <tr>
          <th>Item</th>
          <th>Unit Price</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
       ${formattedItems
         .map(
           (item: any) => `
            <tr>
              <td>${item.name}</td>
              <td>${item.unitPrice}</td>
              <td>${item.buyerPrice}</td>
            </tr>
          `,
         )
         .join("")}

      </tbody>
    </table>

    <div class="total-section">
      <div class="total-row">
        <span>Items Total</span>
        <span>${itemsTotal}</span>
      </div>

      <div class="total-row">
        <span>Delivery Fee</span>
        <span>${deliveryFee}</span>
      </div>

      <div class="total-row">
        <span>VAT</span>
        <span>Nil</span>
      </div>

      <div class="total-row grand-total">
        <span>Total</span>
        <span>${total}</span>
      </div>
    </div>

    <div class="footer">
      Generated from ${window.location.origin}
    </div>
  `;

  doc.body.appendChild(container);

  setTimeout(() => {
    win.focus();
    win.print();
    win.close();
  }, 300);
}

// <div class="status">${requestDetails?.status || ""}</div>
